import { Store } from "~/bff/types/Store";
import { ClickCollectStatuses, InStoreStatuses } from "~/constants/data-layer";

import { getTranslationsByStatusKey } from "./get-translations-by-status-key";

export const inStoreStatusGA = (
  status: string | undefined,
  store?: Store | null,
): string | undefined | null => {
  if (!store?.geomodifier) {
    return ClickCollectStatuses.storeNotYetSelected;
  } else {
    return getTranslationsByStatusKey(InStoreStatuses, status);
  }
};
